import type { LocationQuery } from "vue-router";

const CLASS_HAS_BRANDING_CODE = "has-branding-code";
const CLASS_CODE_PREFIX = "branding-code-";

/** Normalize router/store `code` values (string, array, null). */
export function normalizeBrandingCode(value: unknown): string {
  if (value === undefined || value === null) return "";
  if (Array.isArray(value)) {
    const last = value[value.length - 1];
    return last === undefined || last === null ? "" : String(last).trim();
  }
  return String(value).trim();
}

export function brandingCodeFromRouteQuery(q: LocationQuery): string {
  return normalizeBrandingCode(q.code);
}

/**
 * Maps a branding `code` to a safe CSS class fragment (lowercase, [a-z0-9-], max length).
 */
export function slugifyBrandingCodeForClass(code: string): string {
  return code
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 100);
}

/**
 * Reflects the active branding `code` query param on `document.body` for partner CSS without !important.
 * - `has-branding-code` whenever a non-empty code is active
 * - `branding-code-<slug>` when slugify yields a non-empty token (ASCII-ish codes)
 */
export function syncBrandingCodeBodyClass(code: string): void {
  if (typeof document === "undefined") return;
  const body = document.body;

  body.classList.remove(CLASS_HAS_BRANDING_CODE);
  for (const c of [...body.classList]) {
    if (c.startsWith(CLASS_CODE_PREFIX)) {
      body.classList.remove(c);
    }
  }

  const trimmed = code.trim();
  if (!trimmed) return;

  body.classList.add(CLASS_HAS_BRANDING_CODE);
  const slug = slugifyBrandingCodeForClass(trimmed);
  if (slug) {
    body.classList.add(CLASS_CODE_PREFIX + slug);
  }
}
